import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col justify-center items-center min-h-screen text-center p-6 bg-white">
            <img
                src="/404.png"
                alt="404 Not Found"
                className="max-w-xs w-full mb-6"
            />
            <a
                href="/"
                className="inline-block w-[160px] text-center bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
            >
                {t('notFound.button')}
            </a>
        </div>
    );
};

export default NotFoundPage;
